import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { PersonalToken, PersonalTokenUpdate } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class PersonalTokenHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(): Observable<PersonalToken[]> {
    return this.httpApi.get('/oauth/personal_tokens').pipe(
      map(data => data.personalTokens),
      map(tokens =>
        tokens.map((token: any) => ({
          ...token,
          name: token.meta && token.meta.name,
        })),
      ),
    );
  }

  public fetchOne({
    id,
    secureChangeToken,
  }: {
    id: string;
    secureChangeToken: string;
  }): Observable<PersonalToken> {
    return this.httpApi
      .get(`/oauth/personal_tokens/${id}`, { secure_change_token: secureChangeToken })
      .pipe(map(data => data.personalToken));
  }

  public create({
    name,
    secureChangeToken,
  }: {
    name: string;
    secureChangeToken: string;
  }): Observable<PersonalToken> {
    return this.httpApi
      .post('/oauth/personal_tokens', null, {
        personal_token: { meta: { name } },
        secure_change_token: secureChangeToken,
      })
      .pipe(
        map(data => data.personalToken),
        map(token => ({
          ...token,
          name: token.meta && token.meta.name,
        })),
      );
  }

  public updateName({
    id,
    name,
    secureChangeToken,
  }: PersonalTokenUpdate): Observable<PersonalToken> {
    return this.httpApi
      .patch(`/oauth/personal_tokens/${id}`, null, {
        personal_token: { meta: { name } },
        secure_change_token: secureChangeToken,
      })
      .pipe(
        map(data => data.personalToken),
        map(token => ({
          ...token,
          name: token.meta && token.meta.name,
        })),
      );
  }

  public delete({
    id,
    secureChangeToken,
  }: {
    id: string;
    secureChangeToken: string;
  }): Observable<void> {
    return this.httpApi.delete(`/oauth/personal_tokens/${id}`, {
      secure_change_token: secureChangeToken,
    });
  }
}
